import { z } from "zod";

const SalesReportDataV4Schema = z.object({
    property_name: z.string(),
    booking_date: z.string(),
    source: z.string(),
    reservation_number: z.string(),
    guest_name: z.string(),
    checkin_date: z.string(),
    checkout_date: z.string(),
    extra: z.string(),
    amount: z.string(),
});

const SalesReportTotalV4Schema = z.object({
    extra: z.string(),
    amount: z.string(),
});

export const SalesReportResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(SalesReportDataV4Schema),
    total: SalesReportTotalV4Schema,
});

export type SalesReportDataV4 = z.infer<typeof SalesReportDataV4Schema>;
export type SalesReportResponseV4 = z.infer<typeof SalesReportResponseV4Schema>;